// extracted by mini-css-extract-plugin
export default {"container":"MobileLine_container__NBDAe","bg":"MobileLine_bg__6DT8z"};